import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { fetchWedding, updateWedding } from '../../../actions/WeddingActions';
import { fetchRegistry } from '../../../actions/RegistryActions';
import { updateUserStatus } from '../../../actions/UserActions';
import * as NotificationService from '../../../actions/NotificationActions';
import WeddingDetails from './WeddingDetails';

class WeddingDetailsContainer extends Component {
  constructor(props) {
    super(props);

    this.handleUpdateWeddingDetails = this.handleUpdateWeddingDetails.bind(this);
  }

  componentDidMount() {
    const { handleFetchWeddingDetails, handleFetchRegistry } = this.props;
    handleFetchWeddingDetails();
    handleFetchRegistry();
  }

  handleUpdateWeddingDetails(data) {
    const { handleUpdateWeddingDetails, showSuccessNotification, handleUpdateUserStatus } = this.props;
    const request = {
      ...data,
      event_date: data.skipDate ? null : moment.utc(data.wedding_date),
      wedding_date: data.skipDate ? null : moment.utc(data.wedding_date).format('YYYY-MM-DD')
    };
    const successMessage = 'Your wedding details have been updated!';

    handleUpdateUserStatus().then((userStatus) => {
      if (userStatus.payload.status !== 'IDLE') {
        handleUpdateWeddingDetails(request).then((response) => {
          if (response && response.payload && response.payload.wedding) {
            showSuccessNotification(successMessage);
          }
        });
      } else {
        browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
      }
    });
  }

  render() {
    return (
      <div className="settings-wedding-details__container">
        <Helmet defaultTitle="Wedding Details" />
        <h1 className="settings-page-header">Wedding Details</h1>
        <WeddingDetails onSubmit={this.handleUpdateWeddingDetails} />
      </div>
    );
  }
}

WeddingDetailsContainer.propTypes = {
  handleFetchWeddingDetails: PropTypes.func,
  handleUpdateWeddingDetails: PropTypes.func,
  showSuccessNotification: PropTypes.func,
  handleUpdateUserStatus: PropTypes.func,
  handleFetchRegistry: PropTypes.func
};

const mapStateToProps = state => ({
  weddingDetails: state.wedding.wedding
});

const mapDispatchToProps = dispatch => ({
  handleFetchWeddingDetails: () => dispatch(fetchWedding()),
  handleUpdateWeddingDetails: data => dispatch(updateWedding(data)),
  showSuccessNotification: message => dispatch(NotificationService.confirmation({ message })),
  handleUpdateUserStatus: () => dispatch(updateUserStatus()),
  handleFetchRegistry: () => dispatch(fetchRegistry())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WeddingDetailsContainer);



// WEBPACK FOOTER //
// ./src/components/settings/wedding/WeddingDetailsContainer.jsx